var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Page not found. Go back "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("home")]),_vm._v("?")],1)}
var staticRenderFns = []

export { render, staticRenderFns }